
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaiairportcab() {



const cardData = {
  keyword: 'Navi Mumbai Airport Cab',
  heading: 'Skyline Cabs: Navi Mumbai Airport Cab',
  headingDescription: 'Skyline Cabs provides professional, punctual, and affordable Navi Mumbai Airport Cab services designed for stress-free airport transfers. Whether you need a Navi Mumbai Airport pickup cab, airport drop cab, or round-trip transfer, we ensure timely arrivals and smooth departures every time. Our fleet includes sedan cabs like Swift Dzire and Hyundai Aura, Ertiga cab, Innova Crysta, premium SUV cab, luxury airport cab, and Tempo Traveller for group travel. We monitor flight schedules to adjust pickup timing in case of delays, ensuring zero waiting stress for passengers. With transparent pricing, no hidden charges, experienced chauffeurs, and 24x7 online cab booking Navi Mumbai Airport support, Skyline Cabs is the most reliable airport transfer service in Navi Mumbai. Book cab for Navi Mumbai Airport today and experience comfort, safety, and professionalism at its best.',

  top: 'Top Places to Visit in Navi Mumbai with Skyline Cabs',

  "topPlaces": [
    {
      "title": "Central Park, Kharghar",
      "description": "Central Park in Kharghar is one of the largest urban parks in India, offering beautifully landscaped gardens, jogging tracks, fountains, and cultural event spaces. Spread across vast acres, it is a perfect destination for morning walks, fitness routines, and family outings. The amphitheater hosts events and gatherings throughout the year. Visitors enjoy panoramic views of Kharghar Hills, making it a scenic relaxation spot. When booking a Navi Mumbai Airport Cab with Skyline Cabs, you can conveniently plan a peaceful stop at Central Park before or after your flight journey."
    },
    {
      "title": "Pandavkada Waterfalls",
      "description": "Pandavkada Waterfalls, located near Kharghar Hills, is a stunning monsoon attraction known for its natural beauty and serene environment. During rainy season, the waterfall flows magnificently, attracting trekkers and nature lovers from across Maharashtra. Surrounded by lush greenery, it provides a refreshing escape from city life. It is a popular photography and adventure spot for tourists visiting Navi Mumbai. Skyline Cabs makes it easy to explore this scenic location with safe and comfortable cab service in Navi Mumbai."
    },
    {
      "title": "Belapur Fort",
      "description": "Belapur Fort is a historic 16th-century structure offering breathtaking views of the Navi Mumbai skyline and surrounding creek areas. Built during the Portuguese era, it reflects rich architectural heritage and strategic importance. The fort is surrounded by greenery, making it a peaceful trekking and exploration destination. History lovers and photography enthusiasts frequently visit this landmark. With Skyline Cabs’ reliable airport cab Navi Mumbai service, you can easily add Belapur Fort to your city travel itinerary."
    },
    {
      "title": "DY Patil Stadium",
      "description": "DY Patil Stadium is a world-class sports and entertainment venue in Navi Mumbai, hosting cricket matches, IPL games, concerts, and large-scale events. Its modern architecture and massive seating capacity make it one of the city’s most prominent landmarks. The stadium area is lively during events and offers dining and shopping options nearby. Whether attending a sports event or concert, Skyline Cabs ensures smooth pickup and drop services across Navi Mumbai."
    },
    {
      "title": "Palm Beach Road",
      "description": "Palm Beach Road is famous for its scenic sea-facing drive connecting Vashi to Belapur. Known as one of India’s most beautiful roads, it offers mesmerizing sunset views and calm surroundings. The road is perfect for long drives, photography, and relaxing evening outings. Travelers often enjoy its clean infrastructure and peaceful environment. Skyline Cabs provides comfortable SUV cab and sedan cab options to experience this beautiful stretch in complete comfort."
    },
    {
      "title": "Nerul Balaji Temple",
      "description": "Nerul Balaji Temple is inspired by the famous Tirupati Balaji Temple and is a major spiritual destination in Navi Mumbai. Built on a small hill, it offers peaceful surroundings and impressive architecture. Devotees visit regularly for prayers and religious ceremonies. The temple provides beautiful panoramic views of the city. With Skyline Cabs’ airport transfer service Navi Mumbai, you can travel comfortably to this divine location."
    },
    {
      "title": "Rock Garden, Nerul",
      "description": "Rock Garden in Nerul is a beautifully landscaped garden featuring artistic sculptures, seating areas, and sea-facing viewpoints. It is ideal for family outings, children’s playtime, and couples seeking a calm environment. The garden is well-maintained and offers peaceful surroundings away from traffic noise. It’s a hidden gem for relaxation in Navi Mumbai."
    },
    {
      "title": "Karnala Bird Sanctuary",
      "description": "Karnala Bird Sanctuary, located near Navi Mumbai, is home to more than 200 species of birds and lush forest landscapes. Nature enthusiasts and bird watchers frequently visit this eco-tourism destination. The sanctuary also offers trekking trails leading to Karnala Fort. It’s a perfect weekend getaway near the city."
    },
    {
      "title": "Seawoods Grand Central Mall",
      "description": "Seawoods Grand Central Mall is one of Navi Mumbai’s largest shopping and entertainment hubs. It offers premium brand stores, restaurants, multiplex cinemas, and family entertainment zones. Visitors enjoy shopping, dining, and leisure activities under one roof. Skyline Cabs ensures hassle-free travel to and from this popular mall."
    },
    {
      "title": "Utsav Chowk, Kharghar",
      "description": "Utsav Chowk is known for its European-inspired architecture and vibrant atmosphere. It is surrounded by cafes, restaurants, and shopping outlets, making it a popular evening hangout spot. The beautifully designed fountain area adds to its charm. It’s a lively and picturesque location in Navi Mumbai."
    }
  ],

  "services": [
    {
      "name": "Navi Mumbai Airport Cab Booking",
      "description": "Book cab for Navi Mumbai Airport instantly with Skyline Cabs. We offer online cab booking Navi Mumbai Airport with real-time confirmation, transparent fares, and multiple vehicle options including sedan cab, SUV cab, Innova Crysta, Ertiga, and Tempo Traveller."
    },
    {
      "name": "Navi Mumbai Airport Pickup Cab",
      "description": "Our Navi Mumbai Airport pickup cab service includes flight tracking, professional chauffeurs, and on-time arrival at the terminal. We ensure smooth airport transfers without delays or waiting charges."
    },
    {
      "name": "Navi Mumbai Airport Drop Cab",
      "description": "Need a drop to Navi Mumbai Airport? Our drop cab service guarantees timely arrival, luggage assistance, and comfortable ride experience for business and leisure travelers."
    },
    {
      "name": "Innova Crysta Navi Mumbai Airport Cab",
      "description": "Travel in premium comfort with Innova Crysta Navi Mumbai Airport Cab service. Spacious interiors, smooth suspension, and luxury comfort make it ideal for corporate and family airport transfers."
    },
    {
      "name": "Sedan & Ertiga Cab Navi Mumbai Airport",
      "description": "Choose Swift Dzire, Hyundai Aura sedan cab, or Ertiga cab to Navi Mumbai Airport for affordable and comfortable airport taxi service with transparent pricing."
    },
    {
      "name": "Tempo Traveller to Navi Mumbai Airport",
      "description": "Planning group airport travel? Book Tempo Traveller to Navi Mumbai Airport for spacious seating and comfortable group transfers."
    }
  ],

  "tableData": [
    ["Navi Mumbai Airport Cab", "Navi Mumbai Airport Taxi Service"],
    ["Navi Mumbai Airport Pickup Cab", "Navi Mumbai Airport Drop Cab"],
    ["Book Cab for Navi Mumbai Airport", "Online Cab Booking Navi Mumbai Airport"],
    ["Cheapest Cab to Navi Mumbai Airport", "Best Cab Service Navi Mumbai Airport"],
    ["Reliable Airport Cab Navi Mumbai", "Luxury Cab Navi Mumbai Airport"],
    ["Innova Crysta Navi Mumbai Airport Cab", "Ertiga Cab Navi Mumbai Airport"],
    ["Sedan Cab Navi Mumbai Airport", "SUV Cab Navi Mumbai Airport"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Reliable & Punctual Navi Mumbai Airport Cab Service",
      "WhyChoosedescription": "Skyline Cabs ensures on-time pickup and drop for Navi Mumbai Airport transfers with professional chauffeurs who are trained in airport routes and traffic management. We monitor live flight schedules to adjust pickup timings in case of delays or early arrivals. Our drivers arrive before time to avoid last-minute rush. Whether you need an early morning airport drop or late-night airport pickup, we guarantee punctual service. Our reliability makes us one of the best cab services in Navi Mumbai for airport transfers."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles for Airport Travel",
      "WhyChoosedescription": "From affordable sedan cab like Swift Dzire and Hyundai Aura to premium Innova Crysta, Ertiga cab, SUV cab, luxury airport cab, and Tempo Traveller, Skyline Cabs offers multiple vehicle options for Navi Mumbai Airport transfers. Whether you are a solo traveler, family group, or corporate executive, we provide the right vehicle according to your comfort and luggage requirements. All vehicles are clean, air-conditioned, and well-maintained."
    },
    {
      "WhyChooseheading": "Transparent Pricing & No Hidden Charges",
      "WhyChoosedescription": "With Skyline Cabs, you get clear and upfront pricing for Navi Mumbai Airport taxi service. Our fare includes tolls, fuel charges, and driver allowances with no hidden fees. We provide affordable rates for cheapest cab to Navi Mumbai Airport without compromising quality and comfort."
    },
    {
      "WhyChooseheading": "24x7 Online Cab Booking Navi Mumbai Airport",
      "WhyChoosedescription": "Our online cab booking Navi Mumbai Airport system is available 24/7 for instant confirmation and secure payments. Whether you need last-minute booking or advance reservation, Skyline Cabs offers flexible scheduling and round-the-clock customer support for stress-free airport travel."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How do I book a Navi Mumbai Airport Cab online with Skyline Cabs?',
        answer:
            'Booking your Navi Mumbai Airport Cab is simple. Visit our website, enter your pickup or drop location, select the airport option, choose your preferred vehicle, and confirm your ride instantly.',
    },
    {
        id: 2,
        question: 'Do you provide 24/7 Navi Mumbai Airport Cab service?',
        answer:
            'Yes, Skyline Cabs operates 24/7 Navi Mumbai Airport Cab services, including early morning and late-night airport transfers for your convenience.',
    },
    {
        id: 3,
        question: 'Can I pre-book my Navi Mumbai Airport Cab in advance?',
        answer:
            'Absolutely! You can schedule your airport cab in advance for any date and time to ensure timely pickup and stress-free travel.',
    },
    {
        id: 4,
        question: 'What types of vehicles are available for Navi Mumbai Airport transfers?',
        answer:
            'We offer Sedans, SUVs, Ertiga, Innova Crysta, and luxury vehicles for Navi Mumbai Airport Cab bookings — suitable for solo travelers, families, and corporate clients.',
    },
    {
        id: 5,
        question: 'Is the Navi Mumbai Airport Cab fare fixed and transparent?',
        answer:
            'Yes, our airport cab fares are completely transparent and inclusive of tolls, taxes, and driver charges. There are no hidden costs.',
    },
    {
        id: 6,
        question: 'Do you provide airport pickup with flight tracking?',
        answer:
            'Yes, we monitor your flight status to adjust pickup timing in case of delays, ensuring smooth airport pickup and drop services.',
    },
    {
        id: 7,
        question: 'Are online payments available for Navi Mumbai Airport Cab booking?',
        answer:
            'Yes, we support secure online payments via UPI, credit/debit cards, and net banking. Instant confirmation is provided after payment.',
    },
    {
        id: 8,
        question: 'Can I book a round-trip airport cab from Navi Mumbai?',
        answer:
            'Yes, you can select the round-trip option while booking your Navi Mumbai Airport Cab and schedule your return ride easily.',
    },
    {
        id: 9,
        question: 'Is your Navi Mumbai Airport Cab service suitable for corporate travel?',
        answer:
            'Definitely. We provide professional drivers, clean vehicles, on-time service, and billing support for corporate airport transfers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai Airport Cab service?',
        answer:
            'Skyline Cabs offers punctual airport transfers, professional chauffeurs, clean and sanitized cars, competitive pricing, and 24x7 customer support — making us a trusted choice for Navi Mumbai Airport Cab service.',
    },
];

const someReviews = [
    {
        name: "Mr. Rahul Deshmukh",
        rating: 5,
        review: "Booked a Navi Mumbai Airport Cab with Skyline Cabs for my early morning flight. The driver arrived 15 minutes early and the ride was smooth and comfortable. Excellent service!"
    },
    {
        name: "Mrs. Pooja Mehta",
        rating: 4,
        review: "Very reliable airport cab service in Navi Mumbai. The booking process was easy, pricing was transparent, and the car was clean and well-maintained. Will book again!"
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




      
    
      


    return (
        <div>



      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/114.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaiairportcab;